import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { SummaryBox, TextButton } from '~/components';
import styles from './Summary.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRandomInt } from '~/utils/common';
import { useTranslation } from 'react-i18next';
import Confetti from 'react-confetti';

function Summary() {
    const { t } = useTranslation();
    const query = useQuery();
    const bookId = query.get('book');
    const lessonId = query.get('lesson');
    const numberAll = parseInt(query.get('all'));
    const numberCorrect = parseInt(query.get('correct'));
    const testResult = query.get('test');

    const navigate = useNavigate();

    function handleOnClickEndLesson(e) {
        navigate(`/book?id=${bookId}&lesson=${lessonId}`);
    }

    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

    const handleKeyDown = (event) => {
        //console.log('handleKeyDown');
        if (event.key === 'Enter') {
            event.preventDefault();
            handleOnClickEndLesson();
        }
    };

    // Mỗi lần hiện result
    const hiddenInputRef = useRef(null);
    useEffect(() => {
        // focus vào input ẩn để bắt sự kiện phím
        if (hiddenInputRef.current) {
            hiddenInputRef.current.focus();
        }
    }, [hiddenInputRef]);

    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    console.log('message_end_test', t('message_end_test'))
    console.log('testResult', testResult)
    return (
        <main
            className={styles.wrapper}
            style={{
                height: `${viewportHeight}px`,
            }}
        >
            <div className={styles.content}>
                <div className={clsx(styles.summary)}>
                    <img
                        className={clsx(styles.gif)}
                        src={getGifPath(numberAll, numberCorrect, testResult)}
                        alt={'a funny gif'}
                    ></img>
                    {!testResult ?
                        <div className={clsx(styles.tittle)}>
                            {t('message_end_lesson')}
                        </div> : <div className={clsx(styles.tittle)}>
                            {t('message_end_test')}
                        </div>
                    }
                    <div className={clsx(styles.data)}>
                        <SummaryBox
                            className={clsx(styles.summaryBox)}
                            color="#b64dfb"
                            number={numberAll}
                            tittle={t('quantity')}
                        >
                            <i className="fa-regular fa-circle-question"></i>
                        </SummaryBox>
                        <SummaryBox
                            className={clsx(styles.summaryBox)}
                            color="#58cc02"
                            number={numberCorrect}
                            tittle={t('correct_quantity')}
                        >
                            <i className="fa-regular fa-circle-check"></i>
                        </SummaryBox>
                        {testResult ? <SummaryBox
                            className={clsx(styles.summaryBox)}
                            color={testResult === 'PASS' ? "#3c4dff" : "red"}
                            number={
                                testResult === 'PASS' ? "ĐẬU" : "RỚT"
                            }
                            tittle={t('result')}
                        >
                            <i className="fa-solid fa-bullseye"></i>
                        </SummaryBox> :
                            <SummaryBox
                                className={clsx(styles.summaryBox)}
                                color="#3c4dff"
                                number={
                                    Math.floor((numberCorrect / numberAll) * 100) +
                                    '%'
                                }
                                tittle={t('result')}
                            >
                                <i className="fa-solid fa-bullseye"></i>
                            </SummaryBox>}
                    </div>
                    <TextButton
                        className={clsx(styles.btnContinue)}
                        onClick={handleOnClickEndLesson}
                    >
                        {t('continue')}
                    </TextButton>
                </div>
            </div>
            <input
                ref={hiddenInputRef}
                type="checkbox"
                onKeyDown={handleKeyDown}
                className={clsx(styles.hidden)}
            />
            {testResult === 'PASS' && <Confetti />}
        </main>
    );
}
export default Summary;
const getGifPath = (all, correct, testResult) => {
    if (!testResult) {
        const percent = (correct / all) * 100;
        if (percent < 90) {
            return gifListBad[getRandomInt(gifListBad.length)];
        } else {
            return gifListGood[getRandomInt(gifListGood.length)];
        }
    }
    else {
        if (testResult === 'PASS')
            return gifListGood[getRandomInt(gifListGood.length)];
        else
            return gifListBad[getRandomInt(gifListBad.length)];
    }


};
const gifListGood = [
    '/resources/gif/good/good_01.gif',
    '/resources/gif/good/good_02.gif',
    '/resources/gif/good/good_03.gif',
    '/resources/gif/good/good_04.gif',
    '/resources/gif/good/good_05.gif',
    '/resources/gif/good/good_06.gif',
    '/resources/gif/good/good_07.gif',
    '/resources/gif/good/good_08.gif',
    '/resources/gif/good/good_09.gif',
    '/resources/gif/good/good_10.gif',
    '/resources/gif/good/good_11.gif',
    '/resources/gif/good/good_12.gif',
    '/resources/gif/good/good_13.gif',
    '/resources/gif/good/good_14.gif',
    '/resources/gif/good/good_15.gif',
];

const gifListBad = [
    '/resources/gif/bad/bad_01.gif',
    '/resources/gif/bad/bad_02.gif',
    '/resources/gif/bad/bad_03.gif',
    '/resources/gif/bad/bad_04.gif',
    '/resources/gif/bad/bad_05.gif',
    '/resources/gif/bad/bad_06.gif',
    '/resources/gif/bad/bad_07.gif',
    '/resources/gif/bad/bad_08.gif',
];

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
